// ─────────────────────────────────────────────────────────
// config.js — центральний конфіг фронтенду
// Шлях: src/config.js
// Змінюй тільки тут — всі компоненти підхоплять автоматично
// ─────────────────────────────────────────────────────────

// API_URL — протокол-відносний: успадковує http/https зі сторінки
// (локально — http, на проді — https). НЕ повертати на http:// — зламає https-прод.
export const API_URL = process.env.REACT_APP_API_URL ||
  `//${window.location.hostname}/irbis-api`;